import { RowLayout, styled } from '@auth0/quantum-product';
import * as React from 'react';
import NavigationStore from '../../../stores/NavigationStore';
import { ArticleFooter } from '../../ArticleFooter';
import { Breadcrumbs } from '../../Breadcrumbs';
import { useFluxible } from '../../hooks/useFluxible';
import { useTranslation } from '../../hooks/useTranslation';
import { ContentContainer } from '../../layouts';
import { Sidebar } from '../../Sidebar';
import { Spinner } from '../../Spinner';
import { ToC } from '../../ToC';
import { VideoFooter } from '../../VideoFooter';
import { Article } from '../Article';
import { ArticleContextProvider, ArticleType } from '../ArticleContext';
import { LandingPage } from '../LandingPage';
import { ArticleLayout } from '../Layout';
var articleComponentFactory = function (type) {
    var component;
    switch (type) {
        case ArticleType.LandingPage:
            component = LandingPage;
            break;
        case ArticleType.Default:
        default:
            component = Article;
            break;
    }
    return component;
};
var ArticleContainer = styled(ContentContainer)({
    margin: '0 auto',
});
export var ArticleTemplate = function (_a) {
    var _b;
    var contentReady = _a.contentReady, doc = _a.doc, renderContent = _a.renderContent, url = _a.url;
    var supportedLocales = ['fr-ca', 'ja-jp']; //TODO(Rohit): Get this from env
    var meta = doc === null || doc === void 0 ? void 0 : doc.meta;
    var section = meta === null || meta === void 0 ? void 0 : meta.section;
    var classes = (meta === null || meta === void 0 ? void 0 : meta.classes) || '';
    var isVideoPage = classes.search('video-page') > -1;
    var locale = (_b = meta === null || meta === void 0 ? void 0 : meta.locale) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    // const localeTags = meta?.localeTags || [];
    var context = useFluxible();
    var navigationStore = context.getStore(NavigationStore);
    var storeBreadcrumbs = navigationStore.getBreadcrumbs();
    var breadcrumbs = storeBreadcrumbs.length > 0 ? storeBreadcrumbs : (meta === null || meta === void 0 ? void 0 : meta.breadcrumbs) || [];
    var navigationItems = (meta && section && navigationStore.getNavigationItems(section, breadcrumbs)) || [];
    var t = useTranslation('core').t;
    var safeTranslate = function (key, fallback) {
        var translation = t(key);
        return translation !== key ? translation : fallback;
    };
    // Filter navigation items with special handling for 'apis' section
    // Sidebar items for APIs landing page is not coming from contentful but from sidebar.yml hence we need to filter it out
    var filteredItems = (navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.filter(function (navItem) {
        if (section === 'apis') {
            navItem.title = safeTranslate("sidebar.".concat(navItem.title), navItem.title);
            // Handle the 'apis' section differently
            if (locale === 'en-us') {
                //ToDo(Rohit): Please us default env var for en-us
                // For en-us, we exclude items that have any supported locales in the URL
                return !supportedLocales.some(function (supportedLocale) { return navItem.url.includes("/".concat(supportedLocale, "/")); });
            }
            else {
                // For non-'en-us' locales, we check if the locale is already in the URL, and if not, we add it
                if (!navItem.url.includes("/".concat(locale, "/"))) {
                    navItem.url = "/docs/".concat(locale).concat(navItem.url.replace('/docs', ''));
                }
                return navItem.url.includes("/".concat(locale, "/"));
            }
        }
        else {
            // For other sections (non-'apis'), use the standard filtering logic
            if (locale === 'en-us') {
                return !supportedLocales.some(function (supportedLocale) { return navItem.url.includes("/".concat(supportedLocale, "/")); });
            }
            else {
                return navItem.url.includes("/".concat(locale, "/"));
            }
        }
    })) || [];
    // Sidebar and ToC setup
    var sidebar = React.createElement(Sidebar, { section: section, items: filteredItems, maxDepth: 4, url: url });
    var toc = (meta === null || meta === void 0 ? void 0 : meta.toc) && React.createElement(ToC, { titles: meta === null || meta === void 0 ? void 0 : meta.titles.filter(function (t) { return t.level === 2 || t.level === 3; }) });
    var ArticleComponent = articleComponentFactory(meta === null || meta === void 0 ? void 0 : meta.type);
    // const translationDoneTag = `TranslationDone${locale?.replace('-', '')?.toUpperCase()}`;
    // const isTranslated = locale === 'en-us' || localeTags?.some((tag: string) => tag === translationDoneTag);
    return (React.createElement(ArticleContextProvider, { type: meta === null || meta === void 0 ? void 0 : meta.type },
        React.createElement(ArticleContainer, { fullWidth: true },
            React.createElement(ArticleLayout, { sidebar: sidebar, toc: toc },
                !contentReady && React.createElement(Spinner, { size: "large" }),
                contentReady && (React.createElement(RowLayout, { gutter: 5, sx: { py: 5 } },
                    React.createElement(Breadcrumbs, { crumbs: breadcrumbs }),
                    React.createElement("article", { id: "maincontent", role: "main", className: classes },
                        React.createElement(ArticleComponent, { meta: meta, navigationItems: filteredItems }, renderContent(doc))),
                    isVideoPage ? (React.createElement(VideoFooter, null)) : (React.createElement(ArticleFooter, { articleUrl: url, githubEditLink: meta === null || meta === void 0 ? void 0 : meta.editUrl, contentfulId: meta === null || meta === void 0 ? void 0 : meta.contentfulId }))))))));
};
